import {
  CognitoIdentityClient,
  GetIdCommand,
  GetOpenIdTokenCommand,
} from "@aws-sdk/client-cognito-identity";
import { getFromLocalStorage, setLocalStorage } from "../utils/localStorage";

const cacheKey = "anonAuthToken";

export async function getAuthToken(): Promise<{
  Token: string;
  IdentityId: string;
}> {
  const cachedToken = await getFromLocalStorage<{
    Token: string;
    IdentityId: string;
  }>(cacheKey);

  if (cachedToken) {
    return cachedToken;
  }

  const cognitoClient = new CognitoIdentityClient({ region: "eu-west-1" });
  const getIdCommand = new GetIdCommand({
    IdentityPoolId: "eu-west-1:1a018acb-d4f1-43ba-a815-e59c2365a3fe",
  });
  const id = (await cognitoClient.send(getIdCommand)).IdentityId;
  const getOpenIdTokenCommand = new GetOpenIdTokenCommand({ IdentityId: id });

  const token = await cognitoClient.send(getOpenIdTokenCommand);
  if (!token.Token || !token.IdentityId) {
    throw new Error("Failed creating an unauthenticated user");
  }

  await setLocalStorage({
    key: cacheKey,
    value: token,
    expiryMs: 1000 * 60 * 5,
  });

  return token as { Token: string; IdentityId: string };
}
